import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export const exceptionCodesMasterApi = async (params: { dataType: string }) => {
  try {
    const response = await axios.get(getUrl(ApiType.EXCEPTION_CODE_MASTER), { params });
    return response?.data?.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.masterExceptionCodesAPIError, { badRequestOrder: "errorsFirst" });
  }
};
